<template>
  <!-- 类目搜索 -->
  <div class="filter-result">
    <div class="filter-result__title">
      Search results for "<span class="filter-result__keyword">{{ filter.keyword ?? categoryName }}</span>"
    </div>
  </div>
  <div
    class="h5-tab-filters"
    :class="{
      'h5-tab-filters--text-search': filter.categoryId == null
    }"
  >
    <div
      v-if="filter.categoryId"
      class="filter-item filter-item__icon"
      @click="showCategorySearch"
    >
      <Icon
        name="search-l"
      />
      <Transition name="category-search-alert">
        <div
          class="category-search-alert"
          v-show="showCategorySearchAlert"
        >
          <img
            src="@/assets/colorIcon/search.svg"
            alt="search"
          >
          Search within category
        </div>
      </Transition>
    </div>
    <Filter
      class="h5-tab-filters__content"
      v-model:sort="filter.sortMap"
      v-model:price-start="filter.priceStart"
      v-model:price-end="filter.priceEnd"
      @all-submit="onAllSubmit"
    />
  </div>
  <PriceTip class="h5-tab-filters__tip" />
  <CategorySearch
    v-model="categorySearchVisible"
    :fixed="fixed"
    :title="categoryName ?? filter.keyword"
  />
</template>

<script setup>
import { buriedPointUtil } from '@/utils/utils'
import { useEventListener } from '@vueuse/core'
import { useProductList } from '../../hooks/useProductList'
import CategorySearch from './CategorySearch.vue'
import { Icon } from '@/components/Icon'
import { Filter, PriceTip } from '@/components/Filter'

const fixed = ref(false)

useEventListener(window, 'scroll', (e) => {
  const scrollTop = e.target.scrollingElement.scrollTop
  if (scrollTop > 120) {
    fixed.value = true
  } else {
    fixed.value = false
  }
})

const { filter, onReset } = useProductList()

const route = useRoute()

const categoryName = computed(() => route.query.categoryName)

onMounted(() => {
  setTimeout(() => {
    showCategorySearchAlert.value = false
  }, 5000)
})

const categorySearchVisible = ref(false)
const showCategorySearchAlert = ref(localStorage.getItem('categorySearchAlert') !== 'hidden')
const showCategorySearch = () => {
  showCategorySearchAlert.value = false
  localStorage.setItem('categorySearchAlert', 'hidden')
  categorySearchVisible.value = true
}

watch(filter, (val) => {
  onReset()
})

watch(() => filter.sortMap, (val) => {
  const others = {
    sortBy: null,
    isDesc: true
  }
  if (val === null) {
    others.sortBy = 'Best Match'
  } else if (val.monthSold) {
    others.sortBy = 'Bestselling'
  } else if (val.price) {
    others.sortBy = 'price'
    others.isDesc = val.price !== 'asc'
  }
  buriedPointUtil({ eventId: 'MPSF202', others })
})

const onAllSubmit = () => {
  buriedPointUtil({ eventId: 'MPSF201', others: { categoryId: filter.categoryId, filterKeyword: categoryName.value } })
}
</script>

<style lang="less" scoped>
.filter-result {
  padding-top: 16px;
  padding-bottom: 4px;
  font-family: mon-700;
  font-size: 16px;
  color: #232323;

  @media (min-width: 1024px) {
    font-size: 20px;
  }

  &__title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 24px;
  }

  &__keyword {
    color: #052784;
  }
}

.h5-tab-filters {
  margin: 0 -12px;
  padding: 8px 12px;
  z-index: 2;
  position: sticky;
  top: 56px;
  background-color: #FFFFFF;
  display: flex;
  gap: 8px;

  &--text-search {
    top: 104px;
  }

  &__content {
    margin-right: -12px;
    padding-right: 12px;
  }

  &__tip {
    margin-top: 4px;
  }
}

.category-search-alert {
  z-index: 99;
  position: absolute;
  top: calc(100% + 8px);
  left: 0px;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px 8px;
  width: 186px;
  background-color: #B0C7F5;
  border-radius: 4px;
  font-size: 12px;
  font-family: mon-600;
  color: #232323;
  transition: all .8 ease;
  transform-origin: 9px 0px;
  animation: shaking .8s ease infinite;

  > img {
    height: 24px;
    width: 24px;
  }

  &::before {
    content: '';
    position: absolute;
    top: -14px;
    left: 9px;
    display: block;
    width: 0;
    height: 0;
    border: 9px solid transparent;
    border-bottom-color: #B0C7F5;
    border-radius: 10px;
  }

  @keyframes shaking {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-1px);
    }
    100% {
      transform: translateY(0);
    }
  }
}

.category-search-alert-enter-active,
.category-search-alert-leave-active {
  transition: all 0.5s ease-in-out;
  animation: none;
}

.category-search-alert-enter-from,
.category-search-alert-leave-to {
  opacity: 0;
  transform: scale(0);
}

.filter-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  height: 36px;
  background-color: #f5f5f5;
  border-radius: 20px;
  flex-shrink: 0;
  font-size: 12px;
  font-family: mon-600;
  color: #232323;
  transition: width 0.3s ease;

  + .filter-item {
    margin-left: 8px;
  }

  &--active {
    background-color: #052784;
    color: white;
  }

  &__icon {
    padding: 8px;
    font-size: 20px;
  }

  &__hover {
    z-index: 99;
    position: fixed;
    right: 12px;
    bottom: 64px;
    padding: 0;
    height: 40px;
    width: 40px;
    border: 1px solid #EBF1F5;

    > .filter-item__icon {
      font-size: 24px;
    }
  }
}
</style>
